<div class="font-body-1" [formGroup]="parentForm" [class.mr-large-b]="displayContainerStyles">
  <div [formArrayName]="controlName">
    <ng-container *ngFor="let group of formArray.controls; let i = index">
      <div
        [formGroupName]="i"
        [ngClass]="{
          'mr-medium-t': i > 0 && !isNestedArray && !compressedList,
          'mr-xsmall-t': i > 0 && isNestedArray,
          'pr-small-x pr-small-t grey-25-bg nested-array-item': isNestedArray
        }"
        [class]="'form-array-item-' + controlName"
        *ngIf="i === 0 || !hideGroups"
      >
        <div
          *ngIf="displayLabels"
          class="bold-type nordic-blue-900-text mr-xxsmall-b item-label"
          [class.font-body-1]="isNestedArray"
          [class.font-body-1]="!isNestedArray"
        >
          {{ translationPrefix + '.label' | finLocalization }} {{ i + 1 }}
        </div>
        <ng-container *ngTemplateOutlet="formGroup; context: { parentFormGroup: group, index: i }"></ng-container>
        <button
          class="remove-button bold-type nordic-blue-900-text focus-inset"
          type="button"
          [class.mr-small-b]="!compressedList"
          [class.disabled-area]="disabled"
          [ngClass]="'form-array-remove-' + controlName"
          *ngIf="i >= minGroups"
          [disabled]="disabled"
          (click)="removeFormGroup(i)"
        >
          <span class="flex medium-type">
            <fcom-icon
              name="trash"
              class="flex flex--nogrow flex--self-center valign-top minus-ball mr-xxsmall-r icon-medium"
            >
            </fcom-icon>
            <span class="button-text flex-1 flex--self-center pr-small-r"
              >{{ translationPrefix + '.remove' | finLocalization }} {{ displayLabels ? i + 1 : '' }}</span
            >
          </span>
        </button>
      </div>
    </ng-container>
  </div>
  <div
    *ngIf="!hideGroups"
    [ngClass]="{ 'pr-small-x grey-25-bg nested-array-item': isNestedArray }"
    [class.mr-xsmall-t]="formArray.length > 0"
  >
    <button
      type="button"
      class="add-button bold-type focus-inset"
      [ngClass]="'form-array-add-' + controlName"
      [class.mr-xsmall-y]="!compressedList"
      [class.disabled-area]="disabled"
      [class.nordic-blue-900-text]="formArray.length < maxGroups"
      [class.nordic-blue-900-text]="formArray.length >= maxGroups"
      (click)="addFormGroup()"
      [disabled]="formArray.length >= maxGroups || disabled"
      #addGroupButtonElement
    >
      <span class="flex">
        <fcom-icon
          name="plus"
          class="flex flex--nogrow flex--self-center valign-top plus-ball mr-xxsmall-r icon-medium"
        >
        </fcom-icon>
        <span class="button-text flex-1 flex--self-center pr-small-r">{{
          translationPrefix + '.add' | finLocalization
        }}</span>
      </span>
      <span class="is-vishidden">{{ 'formArray.addNewItem' | finLocalization }}</span>
    </button>
  </div>
</div>
